import React from 'react';
import { connect } from 'react-redux';
import { ScrollContainer } from '@beef/legacy-ui-kit';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

import { getIsBundleInBasket } from 'store/common/basket/selectors';
import {
  isScreenBelow800,
  isScreenBelow1004,
  isScreenBelow1280,
} from 'store/common/settings/breakpoint/selectors';
import {
  Bundle,
  composeIsBundleReady,
  getBundlesButtonText,
  getBundlesDiscountPercent,
  getBundlesDiscountText,
  getBundlesFullPriceText,
  getBundlesHeadline,
  getBundlesListModel,
  getBundlesPriceWithoutPromotion,
  getHasEsim,
} from 'store/ProductDetails/bundles/selectors';
import { addBundleToBasket } from 'store/ProductDetails/common/actions';
import { getPreorderOrderButtonText } from 'store/ProductDetails/preorder/selectors';
import {
  getLeasingBundleAvailability,
  getLeasingMonthPayment,
  getProductIsPreorder,
} from 'store/ProductDetails/selectors';
import commonStyles from 'styles/common.pcss';

import BundleBuyButton from './components/BundleBuyButton';
import BundleItemInner from './components/BundleItemInner';
import styles from './styles.pcss';

const cx = classNames.bind({ ...commonStyles, ...styles });

const BundleContainerLayout = ({ isMobile, list }) => (
  <div className={cx('bundles-wrapper')}>
    {list.map((bundle, index) => (
      <div className={cx('bundle-wrapper', isMobile && 'mobile')}>
        <ScrollContainer
          className={cx('conteinet', { 'conteinet--mobile': isMobile })}
          id="promoBundle"
        >
          <BundleItemInner bundle={bundle} index={index} />
        </ScrollContainer>
        {isMobile && <BundleBuyButton bundle={bundle} />}
      </div>
    ))}
  </div>
);

BundleContainerLayout.propTypes = {
  isMobile: PropTypes.bool,
  list: PropTypes.arrayOf(PropTypes.instanceOf(Bundle)),
};

BundleContainerLayout.defaultProps = {
  list: [],
};

const mapStateToProps = (state) => ({
  below1280: isScreenBelow1280(state),
  bundleHasLeasing: getLeasingBundleAvailability(state),
  buttonText: getBundlesButtonText(state),
  discountPercent: getBundlesDiscountPercent(state),
  discountText: getBundlesDiscountText(state),
  fullPriceText: getBundlesFullPriceText(state),
  hasEsim: getHasEsim(state),
  headline: getBundlesHeadline(state),
  isBundleInBasket: (bundleId) => getIsBundleInBasket(bundleId),
  isBundleReady: composeIsBundleReady(state),
  isMobile: isScreenBelow800(state),
  isPreorder: getProductIsPreorder(state),
  isTablet: isScreenBelow1004(state),
  list: getBundlesListModel(state),
  monthPayment: getLeasingMonthPayment(state),
  preorderButtonText: getPreorderOrderButtonText(state),
  priceWithoutPromotion: getBundlesPriceWithoutPromotion(state),
});

const mapDispatchToProps = {
  onButtonClick: addBundleToBasket,
};

export default connect(mapStateToProps, mapDispatchToProps)(BundleContainerLayout);
